import {
  BacnetDevice as bacnetDeviceSdk,
  Site as siteSdk,
} from 'coolremote-sdk';

import useQuery from './useQuery';

export const useGetBacnetParamTemplate = (templateId) => {
  return useQuery({
    queryKey: ['bacnetParamTemplate', templateId],
    queryFn: async () => {
      return bacnetDeviceSdk.getBacnetParameterTemplateById(templateId);
    },
    enabled: !!templateId,
  });
};

export const useGetSiteBacnetParamTemplates = (siteId) => {
  return useQuery({
    queryKey: ['siteBacnetParamTemplates', siteId],
    queryFn: async () => {
      return siteSdk.getSiteBacnetParameterTemplates(siteId);
    },
    enabled: !!siteId,
  });
};
